import { render } from "./ReportIntervalsCards.vue?vue&type=template&id=12536b38"
import script from "./ReportIntervalsCards.vue?vue&type=script&lang=js"
export * from "./ReportIntervalsCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__